import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { QuestionAnswerService } from '../question-answer.service';
import { QuestionAnswer } from '../question-answer';

@Component({
    selector: 'app-question-answer',
    templateUrl: './question-answer.component.html',
    styleUrls: ['./question-answer.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class QuestionAnswerComponent implements OnInit {

	constructor(
		private primengConfig: PrimeNGConfig,
		private questionAnswerService: QuestionAnswerService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.questionAnswer = data.questionAnswer,
			this.statuses = questionAnswerService.statuses;
	}

	@Input() questionAnswer: QuestionAnswer;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	questionAnswerId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		'questionAnswerId': [],
		'questionDesc': [],
		'answerDesc': [],
		'category': [],
		'section': [],
		'website': [],
	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();

		// if we were passed the whole questionAnswer object
		if (this.questionAnswer) {
			this.questionAnswerId = this.questionAnswer.questionAnswerId;
			this.fixDates();
			this.form1.patchValue(this.questionAnswer);
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.questionAnswerId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.questionAnswerService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.questionAnswer = res.data.questionAnswer;
						this.doAdd.emit(this.questionAnswer);
					},
					(err: any) => {
						console.log('questionAnswer-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('questionAnswer: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.questionAnswerService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.questionAnswer = res.data.questionAnswer;
						this.doUpdate.emit(this.questionAnswer);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.questionAnswerService.delete(this.questionAnswer.questionAnswerId)
				.subscribe(
					(res: any) => {
						console.log('questionAnswer-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.questionAnswer);
					},
					(err: any) => {
						console.log('questionAnswer-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			questionAnswerId: [this.questionAnswerId],
			questionDesc: [],
			answerDesc: [],
			category: [],
			section: [],
			website: [],
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.questionAnswer.questionAnswerDate = moment(this.questionAnswer.questionAnswerDate).toDate();
	}
}
